import type { RouteObject } from "react-router-dom";

import { AdminPage } from "./admin/AdminPage";
import { BackPage } from "./back/BackPage";
import { CardPage } from "./card/CardPage";
import { InboxPage } from "./inbox/InboxPage";
import { OnboardingPage } from "./onboarding/OnboardingPage";
import { ProfilePage } from "./profile/ProfilePage";
import "./review_admin.css";

/**
 * F05 web_review_admin: the SME inbox and card, the back-from-SME lane, getting started, my profile and the admin page
 * (BUILD-PLAN 2.11.2). Who may open each path is in `app/screens.ts`; the server checks the role again on every request.
 */
export const routes: RouteObject[] = [
  { path: "/inbox", element: <InboxPage /> },
  { path: "/inbox/:elementId", element: <CardPage /> },
  { path: "/back-from-sme", element: <BackPage /> },
  { path: "/onboarding", element: <OnboardingPage /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/admin", element: <AdminPage /> },
];
